/**
 * Photo de profil fournie par Google OAuth (inchangée même si Auth.photoURL a été écrasée).
 * @param {import('firebase/auth').User | null | undefined} user
 * @returns {string|null}
 */
export function getGoogleProviderPhotoURL(user) {
  if (!user?.providerData?.length) return null
  const google = user.providerData.find((p) => p.providerId === 'google.com')
  const url = google?.photoURL
  if (!url || typeof url !== 'string' || !url.trim()) return null
  return url.trim()
}

/** Compare sans query (Google ajoute souvent ?sz=…). */
export function isSameGoogleProfilePhoto(currentUrl, googleProviderUrl) {
  if (!currentUrl || !googleProviderUrl) return false
  try {
    const a = new URL(currentUrl.trim())
    const b = new URL(googleProviderUrl.trim())
    return a.origin === b.origin && a.pathname === b.pathname
  } catch {
    return currentUrl.trim() === googleProviderUrl.trim()
  }
}
